import { Component, Input } from '@angular/core';
import { WxrlRuleDetail } from '../../services/wxrl-rules.service';

@Component({
  selector: 'afoone-wxrl-summary',
  templateUrl: './wxrl-summary.component.html',
  styleUrls: ['./wxrl-summary.component.css'],
})
export class WxrlSummaryComponent {
  @Input() public rule: WxrlRuleDetail = null;
}

